<div class="sidebar-area bg-white" [ngClass]="{'active': isSidebarToggled}"
    [class.component-dark-theme]="themeService.isDark()" [class.dark-sidebar]="themeService.isSidebarDark()"
    [class.right-sidebar]="themeService.isRightSidebar()" [class.hide-sidebar]="themeService.isHideSidebar()"
    [class.card-borderd-theme]="themeService.isCardBorder()" [class.rtl-enabled]="themeService.isRTLEnabled()">
    <div class="logo bg-white">
        <a routerLink="/dashboard" class="d-flex align-items-center">
            <img src="assets/images/sidebar/stomp-logo1.svg" alt="logo-icon" class="img-logo">
            <span class="fw-semibold">STOMP</span>
        </a>
    </div>

    <!-- Burger menu inside sidebar — toggles it closed on smaller screens -->
    <div (click)="toggle()" class="burger-menu" [ngClass]="{'active': isSidebarToggled}">
        <span class="top-bar"></span>
        <span class="middle-bar"></span>
        <span class="bottom-bar"></span>
    </div>

    <ng-scrollbar visibility="hover">
        <div class="sidebar-inner">
            <div class="sidebar-menu">
                <mat-accordion>
                    <a routerLink="/dashboard" class="sidebar-menu-link" routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}">
                        <i class="material-symbols-outlined">
                            dashboard
                        </i>
                        <span class="title">Dashboard</span>
                    </a>

                    <a routerLink="/application_logs" class="sidebar-menu-link" routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}">
                        <i class="application-logs-icon"></i>
                        <span class="title">Application Logs</span>
                    </a>

                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true"
                        *ngIf="isUser">
                        <mat-expansion-panel-header class="expansion-gap">
                            <mat-panel-title>
                                <a class="sidebar-menu-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">
                                    <i class="ticket-icon"></i>
                                    <span class="title">
                                        IT Tickets
                                    </span>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/Ticketing/CreateProblemsAndIssues" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    New Ticket
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Ticketing/AllTickets" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    All Tickets
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Ticketing/ProjectTickets" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Projects
                                </a>
                            </li>
                            <li class="sidemenu-item" *ngIf="isITSupportUser">
                                <a routerLink="/Ticketing/TicketingReport" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Reports
                                </a>
                            </li>
                            <li class="sidemenu-item" *ngIf="isITSupportUser">
                                <a routerLink="/Ticketing/Dashboard" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Dashboard
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true"
                        *ngIf="isCalibrationUser" style="margin-top: 10px !important">
                        <mat-expansion-panel-header class="expansion-gap">
                            <mat-panel-title>
                                <a class="sidebar-menu-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" style="margin-top: 0px !important;">
                                    <i class="calibration-icon"></i>
                                    <span class="title">
                                        Calibrations
                                    </span>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/EquipmentRegister" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Register
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/EquipmentAllList" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    View Calibrations
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/EquipmentDashboard" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Dashboard
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                        *ngIf="isProdShiftUser" style="margin-top: 10px !important">
                        <mat-expansion-panel-header class="expansion-gap">
                            <mat-panel-title>
                                <a class="sidebar-menu-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }">
                                    <i class="shifts-icon"></i>
                                    <span class="title"> Production Shifts </span>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/ProductionShiftReportCore" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }" class="sidemenu-link">
                                    New Shift
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/ProductionShiftReports" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }" class="sidemenu-link">
                                    All Shifts
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/ProductionShiftsReportViewer" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }" class="sidemenu-link">
                                    Reports
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/ProductionShiftsFinancialReportViewer"
                                    routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                                    class="sidemenu-link">
                                    Finance Reports
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <div class="sidemenu-link kpi-toggle" (click)="kpiOpen = !kpiOpen" style="cursor: pointer;">
                                    KPI
                                </div>
                                <ul class="sidebar-sub-menu" *ngIf="kpiOpen" style="margin-left: 15px;">
                                    <li class="sidemenu-item">
                                        <a routerLink="/Departments/ProductionShiftReports/PerformanceReviewDelays"
                                            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                                            class="sidemenu-link">
                                            PR Delays
                                        </a>
                                    </li>
                                    <li class="sidemenu-item">
                                        <a routerLink="/Departments/ProductionShiftReports/PerformanceReviewGeneratedHours"
                                            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                                            class="sidemenu-link">
                                            PR Generated Hours
                                        </a>
                                    </li>
                                    <li class="sidemenu-item">
                                        <a routerLink="/Departments/ProductionShiftReports/PerformanceReviewProductionOutputs"
                                            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                                            class="sidemenu-link">
                                            PR Production Outputs
                                        </a>
                                    </li>
                                    <li class="sidemenu-item">
                                        <a routerLink="/Departments/ProductionShiftReports/FGDailyReport"
                                            routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }"
                                            class="sidemenu-link">
                                            FG Daily Report
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/ProductionShiftsAdmin" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{ exact: true }" class="sidemenu-link">
                                    Admin
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true"
                        *ngIf="isEngineeringUser" style="margin-top: 10px !important">
                        <mat-expansion-panel-header class="expansion-gap">
                            <mat-panel-title>
                                <a class="sidebar-menu-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" style="margin-top: 0px !important;">
                                    <i class="engineering-icon"></i>
                                    <span class="title">
                                        Engineering
                                    </span>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/EngineeringNewTask" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    New
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/EngineeringCompletedTasks" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    View
                                </a>
                            </li>
                            <li class="sidemenu-item" *ngIf="isEngineeringAdminUser">
                                <a routerLink="/Departments/EngineeringAdmin" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Admin
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true"
                        *ngIf="isDefectReportUser" style="margin-top: 10px !important">
                        <mat-expansion-panel-header class="expansion-gap">
                            <mat-panel-title>
                                <a class="sidebar-menu-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" style="margin-top: 0px !important;">
                                    <i class="defect-icon"></i>
                                    <span class="title">
                                        Defect Reporting
                                    </span>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/ReportADefect" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Report A Defect
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/DefectCompleteInitial" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Complete Initial
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/DefectCompleteFollowUp" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Complete Follow Up
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/DefectReportsViewer" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Reports
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/DefectReports" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Data
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true"
                        *ngIf="isStockTakeUser" style="margin-top: 10px !important">
                        <mat-expansion-panel-header class="expansion-gap">
                            <mat-panel-title>
                                <a class="sidebar-menu-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">
                                    <i class="stock-icon"></i>
                                    <span class="title">
                                        Stock Take
                                    </span>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/TicketSubmissionInit" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    New Data Entry
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/StockTakeData" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Data Entries
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/StockTakeReconData" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Reconciliation Variance
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/AllocatedStockItems" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Allocated Stock Items
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/OpenSalesOrders" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Open Sales Orders
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true"
                        *ngIf="isITAssetUser" style="margin-top: 10px !important">
                        <mat-expansion-panel-header class="expansion-gap">
                            <mat-panel-title>
                                <a class="sidebar-menu-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">
                                    <i class="assists-icon"></i>
                                    <span class="title">
                                        IT Assets
                                    </span>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/ITAssetsForm" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Add Asset
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/ITAssetsList" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    View Assets
                                </a>
                            </li>
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/ITAssetsAudits" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Audits
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>

                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = true"
                        *ngIf="isPersonnelUser" style="margin-top: 10px !important">
                        <mat-expansion-panel-header class="expansion-gap">
                            <mat-panel-title>
                                <a class="sidebar-menu-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">
                                    <i class="assists-icon"></i>
                                    <span class="title">
                                        HR
                                    </span>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/Departments/HR/PersonnelList" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Personnel
                                </a>
                            </li>
                            <li class="sidemenu-item" *ngIf="isPersonnelAdminUser">
                                <a routerLink="/Departments/HR/PersonnelAdmin" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Admin
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>

                    <mat-expansion-panel *ngIf="isAppAdminUser" (opened)="panelOpenState = true"
                        (closed)="panelOpenState = true" style="margin-top: 10px !important">
                        <mat-expansion-panel-header class="expansion-gap">
                            <mat-panel-title>
                                <a class="sidebar-menu-link" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}">
                                    <i class="settings-icon"></i>
                                    <span class="title">
                                        Settings
                                    </span>
                                </a>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/settings/api_apps" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    API Configurations
                                </a>
                            </li>
                        </ul>
                        <ul class="sidebar-sub-menu">
                            <li class="sidemenu-item">
                                <a routerLink="/settings/location-mapping" routerLinkActive="active"
                                    [routerLinkActiveOptions]="{exact: true}" class="sidemenu-link">
                                    Location Mapping
                                </a>
                            </li>
                        </ul>
                    </mat-expansion-panel>

                    <a (click)="logout()" class="sidebar-menu-link" routerLinkActive="active"
                        [routerLinkActiveOptions]="{exact: true}" style="margin-top: 10px; cursor: pointer;">
                        <i class="material-symbols-outlined">
                            logout
                        </i>
                        <span class="title">Logout</span>
                    </a>
                </mat-accordion>
            </div>
        </div>
    </ng-scrollbar>
</div>

<!-- Overlay: clicking outside the sidebar closes it on smaller screens -->
<div class="sidebar-overlay" *ngIf="isSidebarToggled" (click)="toggle()"></div>